import { render, staticRenderFns } from "./SmsSendOriginatorsSelectbox.vue?vue&type=template&id=715f5c5f"
import script from "./SmsSendOriginatorsSelectbox.vue?vue&type=script&lang=js"
export * from "./SmsSendOriginatorsSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports